export default {"src":"/_next/static/media/tax-id.cbd340b2.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};